<template>
  <v-container fluid>
    <div style="text-align: center" class="display-1 font-weight-thin">
      Solicitação de Pagamento para Fornecedor
    </div>

    <v-layout row wrap>
      <v-snackbar v-model="snackbar.ativo" :timeout="snackbar.timeout" top right :color="snackbar.color">{{ snackbar.text
      }}</v-snackbar>

      <!-- RATEIOS -->
      <v-dialog @keydown.esc="dialogRateios = false" v-model="dialogRateios" max-width="1000px">
        <v-card>
          <v-card-title class="blue-grey lighten-4">
            <span class="headline">Rateios</span>
          </v-card-title>
          <h3 class="text-xs-center">
            <span style="color: #005ca3">Valor total da solicitação:</span>
            <span style="color: #ff0d7b">{{ solicitacao.valorTotal }}</span>
          </h3>
          <v-card-text>
            <v-data-table :items="todosRateios" :headers="headersCentroDeCustoView" hide-actions>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.contaGerencial.numero }}</td>
                <td>{{ props.item.contaGerencial.nome }}</td>
                <td>{{ props.item.departamento.nome }}</td>
                <td class="text-xs-center">
                  {{ props.item.departamento.centroDeCusto }}
                </td>
                <td class="text-xs-center">
                  {{
                    converterMoedasReal(
                      props.item.valor,
                      solicitacao.tipoDeMoeda
                    )
                  }}
                </td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="info" @click="dialogRateios = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog @keydown.esc="() => {
          dialogConfirmarReprovacao = false;
          motivoDaReprovacao = '';
        }
        " v-model="dialogConfirmarReprovacao" persistent max-width="500px">
        <v-card>
          <v-card-title class="error">
            <span class="mx-auto text-center" style="font-size: 1.4em; color: white">Digite o motivo da reprovação</span>
          </v-card-title>
          <v-card-text style="background-color: #eceff1">
            <div class="text-xs-center">
              <v-form ref="disapproveForm">
                <v-textarea background-color="#cfd8dc" color="error" v-model="motivoDaReprovacao"></v-textarea>
              </v-form>
              <v-layout row wrap>
                <v-btn color="error" class="ml-0" @click="dialogConfirmarReprovacao = false">Cancelar</v-btn>

                <v-spacer></v-spacer>

                <v-btn color="primary" class="mr-0" @click="enviarParaAprovacao('REPROVAR')">Reprovar</v-btn>
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog @keydown.esc="dialogConfirmarAprovacao = false" v-model="dialogConfirmarAprovacao" max-width="500px">
        <v-card style="background-color: #005ca3">
          <v-card-title primary-title class="pb-0">
            <span style="
                font-size: 1.2em;
                color: white;
                white-space: pre-wrap;
                word-wrap: break-word;
                width: 100%;
                text-align: center !important;
              ">{{ dialogDueDateMessage }}</span>
          </v-card-title>
          <v-card-text class="pt-0">
            <v-layout row wrap v-if="this.solicitacao.status != 'REPROVADO_PELO_PROCURADOR'" class="pb-2">
              <v-btn :disabled="loadingIsMakingRequest" color="white" class="ml-5"
                @click="dialogConfirmarAprovacao = false">Não</v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="loadingIsMakingRequest" color="white" class="mr-5"
                @click="enviarParaAprovacao('APROVAR')">Sim</v-btn>
            </v-layout>

            <v-layout row wrap class="pb-2" v-else>
              <v-btn :disabled="loadingIsMakingRequest" color="white" class="ml-5"
                @click="enviarParaAprovacao('ENVIADO_PARA_CONTABILIDADE')">Contabilidade</v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="loadingIsMakingRequest" color="white" class="mr-5"
                @click="enviarParaAprovacao('ENVIADO_PARA_PROCURADOR')">Procurador</v-btn>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog @keydown.esc="() => {
          aprovadores = null;
          dialogAprovador = false;
          $refs.formApprover.reset();
        }
        " v-model="dialogAprovador" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Selecione um aprovador</span>
          </v-card-title>
          <v-card-text>
            <v-form onsubmit="return false;" v-model="approverIsValid" ref="formApprover">
              <v-autocomplete label="Selecione um aprovador" v-model="aprovadorSelecionado" :rules="approverRules"
                :items="aprovadores" item-text="nome" item-value="id" :loading="loadingApprovers">
                <template slot="no-data">
                  <div class="noDataSlot">{{ msgAprovadorNaoEncontrado }}</div>
                </template>
              </v-autocomplete>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="font-weight: bold" color="red" flat v-if="!loadingCreateRequest" @click.native="() => {
                aprovadores = null;
                dialogAprovador = false;
                $refs.formApprover.reset();
              }
              ">Cancelar</v-btn>
            <v-layout row wrap justify-center v-if="loadingCreateRequest">
              <div style="margin: 20px">
                <v-progress-circular indeterminate color="blue"></v-progress-circular>
              </div>
            </v-layout>

            <v-btn v-if="!loadingCreateRequest" :loading="loadingIsMakingRequest" style="font-weight: bold"
              color="indigo darken-4" flat @click.native="() => {
                  enviarParaAprovacao('ENVIAR_PARA_APROVACAO');
                }
                " :disabled="!approverIsValid">Enviar para aprovação</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog @keydown.esc="() => {
          dialogDueDate = false;
          dialogDueDateMessage = null;
        }
        " v-model="dialogDueDate" max-width="500px">
        <v-card color="info">
          <v-card-title>
            <span class="text-xs-center" style="
                font-size: 1.2em;
                color: white;
                white-space: pre-wrap;
                word-wrap: break-word;
              ">{{ dialogDueDateMessage }}</span>
          </v-card-title>
          <v-card-text class="pt-1">
            <div class="text-xs-center">
              <v-btn style="font-weight: bold" color="white" @click.native="() => {
                  dialogDueDate = false;
                  dialogDueDateMessage = null;
                }
                ">Não</v-btn>
              <v-btn style="font-weight: bold" color="white" @click.native="() => {
                  dialogDueDate = false;
                  dialogDueDateMessage = null;
                  if (!modoVisualizacao) {
                    openApproverDialog();
                  } else if (
                    modoVisualizacao &&
                    solicitacao.status.includes('REPROVADO')
                  ) {
                    openApproverDialog();
                  } else {
                    approveRequest();
                  }
                }
                ">Sim</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog @keydown.esc="fecharDialogDelete" v-model="dialogConfirmar" max-width="500px">
        <v-card style="background-color: #cc0033">
          <v-card-title primary-title>
            <p class="subTitulo" style="color: white; margin: auto; text-align: center">
              Tem certeza que deseja excluir este item?
            </p>
          </v-card-title>
          <v-card-actions>
            <v-btn color="white" style="margin: auto; text-align: center" @click="deletarItem()">Sim</v-btn>
            <v-btn color="white" style="margin: auto; text-align: center" @click="fecharDialogDelete">Não</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-flex class="py-0" xs12 style="height: 100%" v-if="solicitacao.motivo != '' && solicitacao.motivo != null">
        <v-container class="pb-0">
          <v-toolbar class="red lighten-1">
            <v-toolbar-title class="white--text">Motivo reprovação</v-toolbar-title>
          </v-toolbar>

          <v-content class="red lighten-2">
            <v-layout row wrap>
              <v-flex md12 xs12>
                <v-textarea label="Reprovação" prepend-icon="note" v-model="solicitacao.motivo" readonly></v-textarea>
              </v-flex>
            </v-layout>
          </v-content>
        </v-container>
      </v-flex>

      <v-flex xs12 style="height: 100%" class="pt-0 pb-0">
        <v-container class="pt-3 pb-1">
          <v-layout row wrap class="grey lighten-2 mb-4" v-if="solicitacao.mensagemIntegracao != null ||
            verificaPerfilFinanceiro ||
            solicitacao.statusIntegracao
            ">
            <v-toolbar class="blue-grey lighten-4 elevation-2">
              <v-toolbar-title>Status</v-toolbar-title>
            </v-toolbar>
            <div v-if="verificaPerfilFinanceiro">
              <v-layout row wrap>
                <v-flex md12 class="mb-0 pb-0">
                  <p class="formSection mb-0">
                    Liberação do pagamento:
                    <span :class="formataCorIntegracao(solicitacao.pagamentoEstaLiberado)
                      ">{{
    formataPagamentoLiberado(
      solicitacao.pagamentoEstaLiberado
    )
  }}</span>
                  </p>
                  <v-progress-linear indeterminate="true" v-if="loadingValidacao"></v-progress-linear>
                </v-flex>
              </v-layout>
            </div>

            <integracao-mensagem :mensagemIntegracao="solicitacao.mensagemIntegracao"
              :statusIntegracao="solicitacao.statusIntegracao" :ehBox="false"
              @chamaFuncao="enviarParaAprovacao('APROVAR')"></integracao-mensagem>
          </v-layout>

          <v-content class="grey lighten-4">
            <v-toolbar flat class="blue-grey lighten-4 elevation-2">
              <v-toolbar-title>Geral</v-toolbar-title>
            </v-toolbar>
            <v-form v-model="validarPrimeiroForm" ref="primeiroForm">
              <v-layout row wrap>
                <v-flex md4 xs12>
                  <v-autocomplete label="Empresa" v-model="solicitacao.empresaId" :items="empresas.content"
                    item-text="nome" item-value="id" :rules="companyRules" :readonly="verificarPraEditar"
                    :disabled="solicitacao.rateios.length >= 1">
                    <template slot="selection" slot-scope="data">{{ data.item.id }} - {{ data.item.nome }}</template>
                    <template slot="item" slot-scope="data">{{ data.item.id }} - {{ data.item.nome }}</template>
                    <template slot="no-data">
                      <div class="noDataSlot">Nenhuma empresa cadastrada</div>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex md4 xs12>
                  <v-radio-group row :rules="orderTypeRules" v-model="solicitacao.tipoDeSolicitacao"
                    :readonly="verificarPraEditar">
                    <v-radio label="Solicitação de Pagamento" value="PAGAMENTO"></v-radio>
                    <v-radio label="Solicitação de Adiantamento" value="ADIANTAMENTO"></v-radio>
                  </v-radio-group>
                </v-flex>

                <v-flex md4 xs12>
                  <v-autocomplete label="Tipo do Documento" v-model="solicitacao.tipoDoDocumento"
                    :rules="documentTypeRules" :readonly="verificarPraEditar && !verificarPerfilFinanceiro"
                    @change="mudouTipoDeDocumento($event)" item-text="nome" item-value="valor"
                    :items="tiposDeDocumento"></v-autocomplete>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex md4 xs12>
                  <v-text-field label="Número do Documento" v-model="solicitacao.numeroDoDocumento"
                    :readonly="verificarPraEditar && !verificarPerfilFinanceiro" :disabled="desabilitarPorTipoDeDocumento"
                    :rules="validaNumeroDoDoc"></v-text-field>
                </v-flex>

                <v-flex md4 xs12>
                  <v-text-field label="Número do Pedido" v-model="solicitacao.numeroDoPedido" @input="
                    novoDebounceValidacao({
                      $event,
                    })
                    " :readonly="verificarPraEditar && !verificarPerfilFinanceiro" :rules="orderNumberRules"
                    :loading="loadingValidacao"></v-text-field>
                </v-flex>

                <v-flex md4 xs12>
                  <c-seletor-data nomeDoCampo="Data de emissão do documento"
                    :desabilitado="verificarPraEditar && !verificarPerfilFinanceiro" :regras="dataDeEmissao"
                    :data="solicitacao.dataDeEmissaoDoDocumento" :dataMaxima="dataMaximaEmissao"
                    @pegarData="(dataInserida) => solicitacao.dataDeEmissaoDoDocumento = dataInserida"
                    @validacaoFormulario="(formularioValidado) => validacaoEmissaoSeletor = formularioValidado">
                  </c-seletor-data>
                </v-flex>
              </v-layout>
            </v-form>
          </v-content>

          <v-content class="grey lighten-4 mt-3" v-if="modoVisualizacao">
            <v-toolbar flat class="blue-grey lighten-4 elevation-2">
              <v-toolbar-title>Dados do Solicitante</v-toolbar-title>
            </v-toolbar>
            <v-layout row wrap justify-center>
              <v-flex xs10>
                <v-layout row wrap justify-center>
                  <v-flex md4 xs12>
                    <p>
                      <strong>Nome:</strong>
                      {{ solicitacao.usuarioRegistrador.nome }}
                    </p>
                  </v-flex>
                  <v-flex md4 xs12>
                    <p>
                      <strong>E-mail:</strong>
                      {{ solicitacao.usuarioRegistrador.email }}
                    </p>
                  </v-flex>
                  <v-flex md4 xs12>
                    <!-- <p>
                      <strong>Departamento:</strong>
                      {{ solicitacao.usuarioRegistrador.centroDeCusto.nome }}
                    </p> -->
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-content>

          <v-divider class="mx-6 my-2" inset dark></v-divider>

          <v-content class="grey lighten-4">
            <v-toolbar flat class="blue-grey lighten-4 elevation-2">
              <v-toolbar-title>Favorecido</v-toolbar-title>
            </v-toolbar>
            <v-layout row wrap>
              <v-flex xs10>
                <v-text-field label="Cpf, Cnpj ou Nome do fornecedor estrangeiro" append-icon="vignette"
                  v-model="solicitacao.CnpjOuCpfOuNome" :rules="providerRules" :readonly="verificarPraEditar"
                  v-on:keyup.enter="buscarDadosBancarios"></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-btn :loading="loadingProviderData" :disabled="verificarPraEditar" color="#005ca3" class="white--text"
                  @click="buscarDadosBancarios">Filtrar</v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
              <v-layout row wrap justify-center v-if="loadingProviderData" style="margin: 20px">
                <v-progress-circular indeterminate color="blue"></v-progress-circular>
              </v-layout>
              <v-flex xs12 v-if="solicitacao.fornecedor.id === null && !loadingProviderData
                ">Nenhum fornecedor selecionado.</v-flex>
              <v-flex md6 xs12 v-if="!loadingProviderData && solicitacao.fornecedor.id != null">
                <div style="min-height: 250px">
                  <v-card-title class="blue-grey lighten-4">Dados pessoais</v-card-title>
                  <v-card-text>
                    <p>Nome: {{ solicitacao.fornecedor.nome }}</p>
                    <p>
                      Status: {{ formataStatus(solicitacao.fornecedor.status) }}
                    </p>
                  </v-card-text>
                </div>
              </v-flex>
              <v-flex md6 xs12 v-if="!loadingProviderData && solicitacao.fornecedor.id != null">
                <v-card-title class="blue-grey lighten-4">Endereço</v-card-title>
                <v-card-text>
                  <p>
                    Logradouro: {{ solicitacao.fornecedor.endereco.logradouro }}
                  </p>
                  <p>Bairro: {{ solicitacao.fornecedor.endereco.bairro }}</p>
                  <p>Cidade: {{ solicitacao.fornecedor.endereco.cidade }}</p>
                  <p>Estado: {{ solicitacao.fornecedor.endereco.estado }}</p>
                  <p>País: {{ solicitacao.fornecedor.endereco.pais }}</p>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-content>

          <v-divider class="mx-6 my-2" inset dark></v-divider>

          <v-content class="grey lighten-4">
            <v-toolbar flat class="blue-grey lighten-4 elevation-2">
              <v-toolbar-title>Pagamento</v-toolbar-title>
            </v-toolbar>
            <v-form v-model="editPaymentIsValid" ref="editPaymentForm">
              <v-layout row wrap>
                <v-flex md3 xs12>
                  <v-autocomplete label="Forma de Pagamento" v-model="solicitacao.formaDePagamento"
                    :rules="paymentTypeRules" :readonly="verificarPraEditar" :items="formasDePagamento"
                    @change="mudouForma($event)" item-text="nome" item-value="valor"></v-autocomplete>
                </v-flex>
                <v-flex md3 xs12>
                  <v-autocomplete label="Moeda" v-model="solicitacao.tipoDeMoeda" :rules="moneyTypeRules"
                    :items="tiposDeMoeda" item-text="nome" item-value="valor" :readonly="verificarPraEditar"
                    @change="alterarCampoValorTotal($event)"></v-autocomplete>
                </v-flex>
                <v-flex md3 xs12>
                  <!--VALOR RECEBIDO-->
                  <v-text-field label="Valor Total" @blur="formatarValorTotalDoPagamento" @change="zerarParcelas($event)"
                    @input="gerarParcelas()" v-model="solicitacao.valorTotal" :rules="totalValueRules"
                    :readonly="verificarPraEditar"></v-text-field>
                </v-flex>
                <v-flex md3 xs12>
                  <c-seletor-data v-if="solicitacao.formaDePagamento != 'DEPÓSITO' &&
                    solicitacao.formaDePagamento != 'BOLETO'
                    " nomeDoCampo="Data de vencimento" :data="solicitacao.parcelas[0].vencimento"
                    :regras="paymentDateRules"
                    @pegarData="(dataInserida) => solicitacao.parcelas[0].vencimento = dataInserida"
                    @validacaoFormulario="(formularioValidado) => validacaoVencimentoSeletor = formularioValidado">
                  </c-seletor-data>

                  <v-select v-else :readonly="verificarPraEditar" :disabled="solicitacao.valorTotal == null"
                    label="Parcelas" :items="parcelas" v-model="parcelasSelecionadas" @change="gerarParcelas($event)"
                    item-text="texto" item-value="valor"></v-select>
                </v-flex>
              </v-layout>

              <v-layout row wrap justify-center v-if="solicitacao.formaDePagamento === 'DEPÓSITO' ||
                solicitacao.formaDePagamento === 'BOLETO'
                ">
                <v-flex xs12 class="ma-1 pa-0">
                  <v-card class="transparent elevation-0" style="color: #005ca3">
                    <v-layout v-if="!validacaoDataDeVencimentoDasParcelas" justify-center>
                      <p class="body-1 font-weight-bold mt-3" style="color: red">
                        {{
                          `A data de vencimento da parcela ${this.numeroDaParcelaInvalida} está inválida. Deve ser maior que
                        anterior e menor que a posterior.`
                        }}
                      </p>
                    </v-layout>
                    <v-layout row wrap justify-center>
                      <v-flex xs3 v-for="i in this.solicitacao.parcelas" style="border: 1px solid #eceee1">
                        <v-layout row wrap align-center class="px-0">
                          <v-flex xs5 md5 class="pb-0">
                            <p>
                              Parcela {{ i.numero }}
                              <b>{{
                                converterMoedasReal(
                                  converterValorStringEmNumero(i.valor),
                                  solicitacao.tipoDeMoeda
                                )
                              }}</b>
                            </p>
                          </v-flex>
                          <v-flex xs7 md7 class="pb-0 px-0">
                            <c-seletor-data style="width: 80%" nomeDoCampo="Vencimento"
                              :ehEditavel="verificarPraEditar && !verificarPerfilFinanceiro"
                              :desabilitado="i != parcelaEditada && !validacaoDataDeVencimentoDasParcelas"
                              :data="i.vencimento" :regras="[regraDeParcelasObrigatorias, dataDeVencimentoDeParcelaRules]"
                              @pegarData="(dataInserida) => {
                                i.vencimento = dataInserida
                                parcelaEditada = i
                                validarTodasParcelas(validacaoDataDeVencimentoDasParcelas);
                              }">
                            </c-seletor-data>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout row warp justify-center v-if="solicitacao.formaDePagamento === 'DEPÓSITO'">
                <v-layout row wrap justify-center v-if="loadingProviderData" style="margin: 20px">
                  <v-progress-circular indeterminate color="blue"></v-progress-circular>
                </v-layout>

                <v-flex class="pa-0" xs12 v-else>
                  <v-card class="elevation-0 transparent">
                    <v-layout row wrap>
                      <v-flex xs12 md12 style="color: #707070">Selecione uma conta bancária:</v-flex>
                      <v-flex xs12 class="pa-0">
                        <v-data-table :items="solicitacao.fornecedor.dadosBancarios" :headers="headersProvider"
                          no-data-text="Selecione um fornecedor." hide-actions>
                          <template slot="items" slot-scope="props">
                            <tr>
                              <td>
                                <v-checkbox @change="selecionouConta($event, props.index)"
                                  v-model="props.item.selecionado" :disabled="verificarPraEditar ||
                                    solicitacao.fornecedor.dadosBancarios
                                      .length == 1 ||
                                    props.item.selecionado
                                    " class="ml-3 mt-2"></v-checkbox>
                              </td>
                              <td>{{ props.item.banco }}</td>
                              <td>{{ props.item.agencia }}</td>
                              <td>{{ props.item.conta }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout row wrap justify-center v-if="solicitacao.formaDePagamento === 'BOLETO'">
                <v-flex md12 xs12>
                  <v-text-field label="Banco do Boleto" :rules="bancoDoBoletoRules" v-model="solicitacao.pagamento.banco"
                    :value="solicitacao.pagamento.banco" :readonly="verificarPraEditar"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex md12 xs12>
                  <v-textarea label="Finalidade" :rules="goalRules" :value="solicitacao.observacao"
                    v-model="solicitacao.observacao" :readonly="verificarPraEditar"></v-textarea>
                </v-flex>
              </v-layout>
            </v-form>
          </v-content>

          <v-divider class="mx-6 my-2" inset dark></v-divider>

          <v-content class="grey lighten-4">
            <v-toolbar flat class="blue-grey lighten-4 elevation-2">
              <v-toolbar-title>Anexos</v-toolbar-title>
            </v-toolbar>
            <v-layout row wrap justify-center>
              <v-flex md12 class="text-xs-center">
                <i>Documentos fiscais que não são eletrônicos devem constar
                  cópia em anexo e via original para ser entregue no
                  financeiro</i>
                <div v-for="(upload, index) in solicitacao.uploads" :key="upload.id">
                  <a target="_blank" :href="urlParaUpload + `/uploads/${upload.nomeDoArquivo}`">{{
                    upload.nomeDoArquivo.split(/-(.+)/)[1] }}</a>
                  <v-btn v-if="!verificarPraEditar ||
                    verificarAnexoContabilidade ||
                    verificarPerfilFinanceiro
                    " @click.prevent="solicitacao.uploads.splice(index, 1)" color="red" flat small
                    style="padding-left: 0px; margin-left: 0px">
                    <v-icon>delete</v-icon>Remover
                  </v-btn>
                </div>
              </v-flex>

              <v-flex md9 v-if="!verificarPraEditar ||
                verificarAnexoContabilidade ||
                verificarPerfilFinanceiro
                ">
                <span v-if="msgErroAnexo != ''" style="color: red">{{
                  msgErroAnexo
                }}</span>
                <v-list three-line class="blue-grey lighten-5" v-if="files != null || files != ''">
                  <v-subheader>Novos Arquivos Anexados: {{ files.length }}</v-subheader>
                  <v-divider color="#F0F0F0"></v-divider>
                  <v-list-tile v-for="(itemAnexado, index) in files">
                    <v-list-tile-title style="height: auto; margin-top: 20px">
                      {{ Number(index) + 1 }} - {{ itemAnexado.name }}
                      <v-btn @click.prevent="files.splice(index, 1)" color="red" flat small style="
                          float: right;
                          padding-left: 0px;
                          margin-left: 0px;
                        ">
                        <v-icon>delete</v-icon>Remover
                      </v-btn>
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
                <div class="text-xs-center" v-if="!podeVer() ||
                  verificarAnexoContabilidade ||
                  verificarPerfilFinanceiro
                  ">
                  <input accept="image/jpeg, image/png, application/pdf" style="display: none" type="file" ref="files"
                    multiple @change="handleFilesUpload('files')" />
                  <v-btn class="white--text" color="#005ca3" @click="enviarArquivoClique()">Anexar Arquivo</v-btn>
                </div>
                <div v-if="msgErroAnexo != ''" class="text-xs-center mb-2">
                  <span style="color: red">{{ msgErroAnexo }}</span>
                </div>
              </v-flex>
            </v-layout>
          </v-content>

          <v-divider class="mx-6 my-2" inset dark></v-divider>

          <!-- RATEIO*** -->
          <v-content class="grey lighten-4">
            <v-toolbar flat class="blue-grey lighten-4 elevation-2">
              <v-toolbar-title>Rateios</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn small color="#005ca3" title="Ver rateios" fab
                v-if="verificarPraEditar && solicitacao.rateios.length > 1" @click="dialogRateios = true">
                <v-icon>visibility</v-icon>
              </v-btn>

              <v-btn small fab title="Adicionar Rateio" color="#ff0d7b" dark @click="dialogCentro = true" :disabled="solicitacao.empresaId == null || calcularValorTotal == 0
                ">
                <v-icon>add</v-icon>
              </v-btn>

              <importar-rateios :valorTotalRateio="calcularValorTotal" :condicaoParaAparecer="rateioValido"
                :tipoDeMoeda="solicitacao.tipoDeMoeda" @devolverDados="dadosRecebidos"></importar-rateios>
            </v-toolbar>
            <v-layout row wrap>
              <v-flex xs12 class="ma-0 pa-0">
                <v-dialog @keydown.esc="
                  close({
                    dialogName: 'dialogCentro',
                    formName: 'formCentros',
                    itemName: 'editedCostCenter',
                    defaultItemName: 'defaultCostCenter',
                  })
                  " v-model="dialogCentro" max-width="500px" persistent>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ tituloDoForm }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-form v-model="valid" ref="formCentros">
                              <v-autocomplete label="Selecione um Departamento" :items="departamentosDoCentroDeCusto"
                                v-model="editedCostCenter" :rules="departamentoRules" append-icon="business_center"
                                :loading="loadingManagementAccountDepartments" item-text="nome" item-value="id"
                                return-object>
                                <template slot="no-data">
                                  <div class="noDataSlot">
                                    {{ msgDepartamentoNaoEncontrado }}
                                  </div>
                                </template>
                              </v-autocomplete>
                              <v-autocomplete label="Selecione a Conta Gerencial" :items="contasGerenciaisPorEmpresa"
                                v-model="contaGerencialSelecionada" append-icon="business_center"
                                :loading="loadingContaGerencial" :rules="managementAccountRules" item-text="nome"
                                item-value="id" return-object>
                                <template slot="no-data">
                                  <div class="noDataSlot">
                                    {{ msgContaGerencialNaoEncontrada }}
                                  </div>
                                </template>
                              </v-autocomplete>
                              <v-text-field label="Valor" v-model="valorDoCentroDeCusto" @blur="formataValorRateio"
                                append-icon="monetization_on" validate-on-blur :rules="centroDeCustoRules"></v-text-field>
                            </v-form>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="pink" flat @click.native="
                        close({
                          dialogName: 'dialogCentro',
                          formName: 'formCentros',
                          itemName: 'contaGerencialSelecionada',
                          defaultItemName: 'defaultCostCenter',
                        })
                        ">Cancelar</v-btn>
                      <v-btn color="indigo darken-4" flat @click.native="adicionarCentroDeCusto" :disabled="!valid">{{
                        textoDoBotaoDoForm }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-data-table :headers="headersCentroDeCusto" :items="retornaListaCorretaRateios" item-key="index"
                  hide-actions>
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.contaGerencial.numero }}</td>
                    <td>{{ props.item.contaGerencial.nome }}</td>
                    <td>{{ props.item.departamento.nome }}</td>
                    <td>{{ props.item.departamento.centroDeCusto }}</td>
                    <td>
                      {{
                        converterMoedasReal(
                          props.item.valor,
                          solicitacao.tipoDeMoeda
                        )
                      }}
                    </td>
                    <td>
                      <v-tooltip bottom class="paddingTooltip">
                        <v-icon small class="mr-4" :disabled="verificarPraEditar" slot="activator"
                          @click="editarCentroDeCusto(props.item)">edit</v-icon>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip bottom class="paddingTooltip">
                        <v-icon small :disabled="verificarPraEditar" class="mr-2" slot="activator" @click="
                          abrirDialogDelete(props.item, solicitacao.rateios)
                          ">delete</v-icon>
                        <span>Deletar</span>
                      </v-tooltip>
                    </td>
                  </template>
                  <template slot="no-data">
                    <p class="text-xs-center" style="margin: 0; padding: 0">
                      Nenhum rateio Adicionado
                    </p>
                  </template>
                </v-data-table>
              </v-flex>
              <v-layout row wrap style="padding: 5px">
                <v-flex md4 xs12 offset-md9>
                  <span class="texto">Saldo Rateio:</span>
                  {{
                    converterMoedasReal(
                      calcularValorTotal,
                      solicitacao.tipoDeMoeda
                    )
                  }}
                </v-flex>
              </v-layout>
            </v-layout>
          </v-content>

          <v-divider class="mx-6 my-2" inset dark></v-divider>

          <c-impostos v-if="mostrarImpostos" :ehContabilidade="verificarAnexoContabilidade"
            @recebeImpostos="recebeImpostos($event)" :valorTotal="solicitacao.valorTotal"
            :tipoDeMoeda="solicitacao.tipoDeMoeda" :impostos="impostos"></c-impostos>

          <v-divider class="mx-6 my-2" inset dark></v-divider>
          <v-content v-if="solicitacao.id != null">
            <v-toolbar class="yellow lighten-3">
              <v-toolbar-title>Observações</v-toolbar-title>
            </v-toolbar>
            <v-content class="yellow lighten-4">
              <v-layout row wrap>
                <v-flex md12 xs12>
                  <v-textarea v-model="solicitacao.observacoesContabilidade" name="name" prepend-icon="note"
                    :readonly="!podeVisualizar"></v-textarea>
                </v-flex>
              </v-layout>
            </v-content>
          </v-content>
        </v-container>
      </v-flex>

      <v-container class="pt-0">
        <v-content>
          <v-layout row wrap>
            <v-flex class="py-0" md12 xs12>
              <v-btn @click="findWhichDialogToOpen()" style="float: right; font-weight: bold" color="indigo darken-4" flat
                :disabled="loadingIsMakingRequest ||
                  !solicitationIsValid ||
                  !editPaymentIsValid ||
                  !validarPrimeiroForm ||
                  loadingProviderData ||
                  !fornecedorFoiValido ||
                  !solicitacao.rateios.length > 0 ||
                  !(files.length > 0 || solicitacao.uploads.length > 0) ||
                  verificarSaldoTotal || !validacaoEmissaoSeletor || !validarComBaseNoTipoDePagamento
                  " v-if="!modoVisualizacao || !verificarPraEditar">Enviar para Aprovação</v-btn>
              <v-btn color="success" style="float: right" v-if="ehAprovador && podeVisualizar && aprovadorCorreto"
                :loading="loadingIsMakingRequest" :disabled="(!solicitacao.pagamentoEstaLiberado &&
                    verificaPerfilFinanceiro) ||
                  !validarPrimeiroForm
                  " @click.native="conferirExcecao()">Aprovar</v-btn>
              <v-btn color="error" style="float: right" v-if="(ehAprovador && podeVisualizar && aprovadorCorreto) ||
                financeiroVerNoPago
                " :disabled="loadingIsMakingRequest" :loading="loadingIsMakingRequest"
                @click.native="dialogConfirmarReprovacao = true">Reprovar</v-btn>
            </v-flex>
          </v-layout>
        </v-content>
      </v-container>
    </v-layout>

    <v-container class="pb-0">
      <v-content>
        <v-layout row wrap>
          <v-flex class="py-0" md12 xs12>
            <logs-pedidos v-if="solicitacao.logs != null" :logs="solicitacao.logs"></logs-pedidos>
          </v-flex>
        </v-layout>
      </v-content>
    </v-container>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import get from "lodash.get";
import cloneDeep from "lodash.clonedeep";
import moment from "moment";
import business from "moment-business";
import { feriados, converterLogParaHorarioDeSaoPaulo } from "@/mixins/dateMixin.js";
import ImportarRateios from "@/components/solicitacao/ImportarRateios.vue";
import IntegracaoMensagem from "@/components/shared/IntegracaoMensagem.vue";
import LogsPedidos from "@/components/solicitacao/LogsPedidos.vue";
import debounceMixin from "@/mixins/debounceMixin";
import Impostos from "@/components/solicitacao/Impostos";
import conversor from "../../../mixins/moedasMixin.js";
import SeletorData from "../../shared/SeletorData";
import { substituirCaracteres } from '../../../mixins/validarCampos.js';
import { validarSeUsuarioLogadoPodeVerPedido } from "@/mixins/visualizacaoPedidos.js";

export default {
  mixins: [debounceMixin],
  data() {
    return {
      numeroDoDocumentoAnterior: "",
      loadingValidacao: false,
      loadingContaGerencial: false,
      motivoDaReprovacao: "",
      headersCentroDeCustoView: [
        { text: "Nº Conta Gerencial", value: "numDaContaGerencial" },
        {
          text: "Conta Gerencial",
          value: "idDaContaGerencial",
          sortable: false,
        },
        { text: "Nome do Centro de Custo", value: "nome", sortable: false },
        {
          text: "Número do Centro de Custo",
          value: "centroDeCusto",
          align: "center",
        },
        { text: "Valor", value: "valor", align: "center" },
      ],
      todosRateios: [],
      dialogRateios: false,
      ehAprovador: false,
      dialogConfirmarReprovacao: false,
      snackbar: {
        ativo: false,
        timeout: 6000,
        text: "Salvo com successo!",
      },
      tipoDeFornecedorEscolhido: "Pessoa Jurídica",
      dialogConfirmarAprovacao: false,
      fornecedorFoiValido: false,
      loadingProviderData: false,
      solicitationIsValid: true,
      validarPrimeiroForm: true,
      loadingIsMakingRequest: false,
      editPaymentIsValid: true,
      dialogConfirmar: false,
      urlParaUpload: process.env.VUE_APP_API_BACKEND,
      editedCenterIndex: -1,
      headersCentroDeCusto: [
        { text: "Nº Conta Gerencial", value: "contaGerencial.numero" },
        { text: "Conta Gerencial", value: "idDaContaGerencial" },
        { text: "Nome do Centro de Custo", value: "nome" },
        { text: "Número do Centro de Custo", value: "centroDeCusto" },
        { text: "Valor", value: "valor" },
        { text: "Ações", sortable: false },
      ],
      editedCostCenter: null,
      loadingManagementAccountDepartments: false,
      departamentosDoCentroDeCusto: [],
      managementAccountRules: [
        (account) => !!account || "A seleção de uma conta é obrigatória.",
        (contaGerencial) =>
          this.solicitacao.rateios.filter((item) => {
            try {
              if (this.editedCenterIndex == -1) {
                if (
                  item.departamento.id === this.editedCostCenter.id &&
                  item.contaGerencial.id == this.contaGerencialSelecionada.id
                ) {
                  return true;
                } else return false;
              } else {
                for (let i = 0; i < this.solicitacao.rateios.length; i++) {
                  if (i != this.editedCenterIndex) {
                    if (
                      this.solicitacao.rateios[i].departamento.id ===
                      this.editedCostCenter.id &&
                      this.solicitacao.rateios[i].contaGerencial.id ==
                      this.contaGerencialSelecionada.id
                    ) {
                      return true;
                    } else return false;
                  }
                }
              }
            } catch (E) {
            }
          }) == false || "Conta gerencial com centro de custo já cadastrado.",
      ],
      contaGerencialSelecionada: null,
      contasGerenciaisPorEmpresa: [],
      valid: false,
      files: "",
      msgErroAnexo: "",
      totalValueRules: [
        (value) => !!value || "O valor total do pedido é obrigatório.",
        (value) => {
          const pattern = new RegExp("[0-9,]+");
          const res = pattern.test(value);
          return res || "Digite apenas números.";
        },
      ],
      tiposDeMoeda: [
        {
          valor: "BRL",
          nome: "R$ - Real Brasileiro",
        },
        {
          valor: "USD",
          nome: "US$ - Dólar dos EUA",
        },
        {
          valor: "AUD",
          nome: "A$ - Dólar Australiano",
        },
        {
          valor: "CAD",
          nome: "C$ - Dólar do Canadá",
        },
        {
          valor: "JPY",
          nome: "¥ - Iene",
        },
        {
          valor: "EUR",
          nome: "€ - Euro",
        },
        {
          valor: "GBP",
          nome: "£ - Libra",
        },
        {
          valor: "SGD",
          nome: "S$ - Dólar da Singapura",
        },
        {
          valor: "MXN",
          nome: "Mex$ - Peso Mexicano",
        },
      ],
      moneyTypeRules: [
        (type) => !!type || "A seleção do tipo de moeda é obrigatória.",
      ],
      goalRules: [(finalidade) => {
        const campoFinalidade = typeof finalidade === 'undefined';
        // Gambiarra de ultima hora rs
        if (campoFinalidade || finalidade.length <= 10) {
          return "Finalidade deve ter no mínimo 10 caracteres."
        }
        if (finalidade.length > 255) {
          return `Finalidade excedeu o limite de caracteres. 
            O número máximo permitido é de 255 caracteres`
        }

      }],
      bancoDoBoletoRules: [(type) => !!type || "Banco do boleto obrigatório."],
      formasDePagamento: [
        { nome: "Boleto Bancário", valor: "BOLETO" },
        { nome: "Ordem de Pagamento", valor: "ORDEM_DE_PAGAMENTO" },
        { nome: "Depósito Bancário", valor: "DEPÓSITO" },
        { nome: "Câmbio", valor: "CÂMBIO" },
        { nome: "Tributos/Concessionária", valor: "TRIBUTOS" },
        { nome: "Cartão de Crédito", valor: "CARTÃO_DE_CRÉDITO" },
        { nome: "Sispag (Exclusivo DP)", valor: "SISPAG" },
      ],
      validaNumeroDoDoc: [
        (v) => {
          if (!this.desabilitarPorTipoDeDocumento && v == "")
            return "Número do documento obrigatório para este tipo de documento.";
          else return true;
        },
      ],
      paymentTypeRules: [
        (type) => !!type || "A seleção de um tipo de pagamento é obrigatória.",
      ],
      providerRules: [
        (provider) => !!provider || "A seleção de um fornecedor é obrigatória.",
      ],
      paymentDateRules: [
        (data) => {
          if (data == "Invalid date") return "Data de vencimento é obrigatória"
          else return data.length >= 8 || "Digite uma data válida."
        },
        (v) => {
          let anoDaDataRecebida = moment(v, "DDMMYYYY").year();
          if (anoDaDataRecebida < 2000 || anoDaDataRecebida > 2099) {
            return "Ano Inválido.";
          } else return true;
        },
      ],
      regraDeParcelasObrigatorias: (data) => {
        if (data == "Invalid date" || data == "") return "Data de vencimento é obrigatória."
        else return data.length >= 8 || "Digite uma data válida."
      },
      dataDeEmissao: [
        (v) => {
          if (v != null) {
            let dataRecebida = moment(v, "DDMMYYYY");
            let hoje = moment();
            if (moment(dataRecebida).isAfter(hoje)) {
              return "A data de emissão não pode ser maior que a de hoje.";
            } else return true;
          }
        },
        (v) => {
          let anoDaDataRecebida = moment(v, "DDMMYYYY").year();
          if (anoDaDataRecebida < 2000) {
            return "Ano Inválido.";
          } else return true;
        },
        (v) => {
          if (v == "Invalid date") return "Data de emissão é obrigatória"
          else return v.length >= 8 || "Digite uma data válida."
        }
      ],
      tiposDeDocumento: [
        { nome: "Boleto", valor: "BOLETO" },
        { nome: "Concessionárias", valor: "CONCESSIONARIAS" },
        {
          nome: "Conta de Energia Elétrica",
          valor: "CONTA_DE_ENERGIA_ELETRICA",
        },
        { nome: "Conta Telefônica", valor: "CONTA_TELEFONICA" },
        { nome: "Fatura", valor: "FATURA" },
        { nome: "Invoice", valor: "INVOICE" },
        {
          nome: "NF de Serviço Eletrônica - NFS-e",
          valor: "NF_DE_SERVICO_ELETRONICA__NFS_E",
        },
        { nome: "Nota de Débito", valor: "NOTA_DE_DEBITO" },
        { nome: "Nota Fiscal", valor: "NOTA_FISCAL" },
        { nome: "Nota Fiscal - DANFE", valor: "NOTA_FISCAL_DANFE" },
        { nome: "NF de Autônomo", valor: "NOTA_FISCAL_DE_AUTONOMO" },
        { nome: "Nota Fiscal de Serviço", valor: "NOTA_FISCAL_DE_SERVICO" },
        { nome: "Recibo", valor: "RECIBO" },
        { nome: "RPA", valor: "RPA" },
        { nome: "Adiantamento de Despesas", valor: "ADIANTAMENTO_DE_DESPESAS" },
        {
          nome: "Adiantamento de Fornecedor",
          valor: "ADIANTAMENTO_FORNECEDOR",
        },
        { nome: "DAE", valor: "DAE" },
        { nome: "DAM", valor: "DAM" },
        { nome: "DARF", valor: "DARF" },
        { nome: "Depósito Judicial", valor: "DEPOSITO_JUDICIAL" },
        { nome: "Estorno a Cliente", valor: "ESTORNO_A_CLIENTE" },
        { nome: "GPS", valor: "GPS" },
        { nome: "Impostos e Taxas", valor: "IMPOSTOS_E_TAXAS" },
        { nome: "Pagamento de Pessoal", valor: "PAGAMENTO_DE_PESSOAL" },
      ],
      dialogCentro: false,
      validado: false,
      aprovadorEstaValidado: false,
      companyRules: [
        (company) => !!company || "A seleção de uma empresa é obrigatória.",
      ],
      orderNumberRules: [
        numero => !!numero || "Número de pedido é obrigatório.",
        numero => isNaN(numero) ? "Este campo só pode conter números" : true
      ],
      documentTypeRules: [
        (type) => !!type || "Tipo de documento é obrigatório.",
      ],
      orderTypeRules: [(type) => !!type || "Tipo do pedido é obrigatório."],
      departamentoRules: [
        (department) =>
          !!department || "A seleção de um centro de custo é obrigatória",
      ],
      centroDeCustoRules: [
        (value) => {
          // Valor total do rateio
          let pagamentoSemVirgula;
          // Variavel Value
          let valorSemVirgula;
          if (this.solicitacao.valorTotal !== null) {
            pagamentoSemVirgula = conversor.methods.converterValorStringEmNumero(
              this.solicitacao.valorTotal,
              this.solicitacao.tipoDeMoeda
            );
          }

          if (value !== null) {
            valorSemVirgula = conversor.methods.converterValorStringEmNumero(
              value,
              this.solicitacao.tipoDeMoeda
            );
          }

          if (this.solicitacao.valorTotal === null) {
            return "Valor total do pedido deve ser preenchido antes de fazer o rateio.";
          } else if (Number(valorSemVirgula) > Number(pagamentoSemVirgula)) {
            return "Valor de rateio no centro de custo não pode ser maior ao valor total.";
          } else {
            if (this.editedCenterIndex === -1) {
              if (
                Number(valorSemVirgula) >
                Number(Number(this.calcularValorTotal).toFixed(2))
              ) {
                return `Valor de todos os rateios não pode ultrapassar o valor total do pedido.`;
              }
            } else {
              let resultadoPraCalculo = 0;
              this.solicitacao.rateios.map((item, index) => {
                if (this.editedCenterIndex != index) {
                  resultadoPraCalculo += item.valor;
                }
              });
              resultadoPraCalculo =
                resultadoPraCalculo +
                Number(
                  conversor.methods.converterValorStringEmNumero(
                    value,
                    this.solicitacao.tipoDeMoeda
                  )
                );
              if (
                resultadoPraCalculo >
                conversor.methods.converterValorStringEmNumero(
                  this.solicitacao.valorTotal,
                  this.solicitacao.tipoDeMoeda
                )
              ) {
                return `Valor de todos os rateios não pode ultrapassar o valor total do pedido.`;
              }
            }

            return true;
          }
        },
        (value) => {
          if (
            Number(
              conversor.methods.converterValorStringEmNumero(
                value,
                this.solicitacao.tipoDeMoeda
              )
            ) <= 0
          )
            return `O valor do rateio não pode ser zerado.`;
        },
        (value) => !!value || "O valor do rateio é obrigatório.",
      ],
      modoVisualizacao: false,
      impostos: {
        irpj: "0",
        iss: "0",
        cofins: "0",
        pis: "0",
        inss: "0",
        csll: "0",
        ajuste: "0",
      },
      parcelasSelecionadas: 1,
      solicitacao: {
        id: null,
        observacoesContabilidade: null,
        empresaId: null,
        usuarioRegistrador: {
          id: null,
          nome: null,
          email: null,
        },
        status: "",
        rateios: [],
        parcelas: [
          {
            numero: 1,
            vencimento: "",
            valor: null,
          },
        ],
        tipoDeSolicitacao: "PAGAMENTO",
        tipoDoDocumento: "",
        numeroDoDocumento: "",
        numeroDoPedido: "",
        dataDeEmissaoDoDocumento: "",
        CnpjOuCpfOuNome: "",
        fornecedor: {
          id: null,
          nome: null,
          status: null,
          endereco: {
            estado: null,
            cidade: null,
            logradouro: null,
            pais: {
              nome: null,
            },
          },
          dadosBancarios: [],
        },
        formaDePagamento: "",
        tipoDeMoeda: "BRL",
        valorTotal: null,
        pagamento: {
          conta: {
            id: null,
          },
        },
        uploads: [],
        excecao: false,
      },
      aprovadores: [],
      loadingApprovers: false,
      dialogAprovador: false,
      nomeDoArray: null,
      valorDoCentroDeCusto: null,
      observacao: "",
      dialogDueDate: false,
      dialogDueDateMessage: "",
      approverIsValid: true,
      approverRules: [(approver) => !!approver || "Selecione um aprovador."],
      loadingCreateRequest: false,
      aprovadorSelecionado: null,
      dadosCompletosDoFornecedor: {},
      validacaoDataDeVencimentoDasParcelas: true,
      numeroDaParcelaInvalida: -1,
      parcelaEditada: null,
      dataDeVencimentoDeParcelaRules: (value) => {
        if (this.parcelaEditada != null) {
          let indexDaParcela = this.solicitacao.parcelas.indexOf(
            this.parcelaEditada
          );
          if (this.parcelasSelecionadas > 1) {
            if (indexDaParcela == 0) {
              if (this.validarPrimeiraParcela(indexDaParcela)) {
                this.validacaoDataDeVencimentoDasParcelas = false;
                this.numeroDaParcelaInvalida = this.solicitacao.parcelas[
                  indexDaParcela
                ].numero;
                return "Data de vencimento inválida";
              } else {
                this.validacaoDataDeVencimentoDasParcelas = true;
                this.numeroDaParcelaInvalida = -1;
                this.parcelaEditada = null;
                return true;
              }
            } else if (indexDaParcela == this.solicitacao.parcelas.length - 1) {
              if (this.validarUltimaParcela(indexDaParcela)) {
                this.validacaoDataDeVencimentoDasParcelas = false;
                this.numeroDaParcelaInvalida = this.solicitacao.parcelas[
                  indexDaParcela
                ].numero;
                return "Data de vencimento inválida";
              } else {
                this.validacaoDataDeVencimentoDasParcelas = true;
                this.numeroDaParcelaInvalida = -1;
                this.parcelaEditada = null;
                return true;
              }
            } else {
              if (this.validarParcelasDoMeio(indexDaParcela)) {
                this.validacaoDataDeVencimentoDasParcelas = false;
                this.numeroDaParcelaInvalida = this.solicitacao.parcelas[
                  indexDaParcela
                ].numero;
                return "Data de vencimento inválida";
              } else {
                this.validacaoDataDeVencimentoDasParcelas = true;
                this.numeroDaParcelaInvalida = -1;
                this.parcelaEditada = null;
                return true;
              }
            }
          } else {
            this.validacaoDataDeVencimentoDasParcelas = true;
            this.numeroDaParcelaInvalida = -1;
            this.parcelaEditada = null;
            return true;
          }
        } else {
          this.validacaoDataDeVencimentoDasParcelas = true;
          this.numeroDaParcelaInvalida = -1;
          this.parcelaEditada = null;
          return true;
        }
      },
      validacaoVencimentoSeletor: false,
      validacaoEmissaoSeletor: false,
      parcelasValidadas: false,
      dataMaximaEmissao: moment().format('YYYY-MM-DD')
    };
  },
  methods: {
    conferirExcecao() {
      let pedidoEhExcecao = false;

      if (this.solicitacao.status == "ENVIADO_PARA_GESTOR") {
        pedidoEhExcecao = this.retornaExcecao("dialogConfirmarAprovacao");
      }

      if (!pedidoEhExcecao) {
        this.dialogDueDateMessage = this.retornaTextoCorretoParaFinanceiro;
        this.dialogConfirmarAprovacao = true;
      }
    },
    retornaExcecao(dialogParaAbrir) {
      const range = this.calculaRangeDeData(
        this.solicitacao.parcelas[0].vencimento
      );

      const today = new Date(new Date().setHours(0, 0, 0, 0));
      const [ano, mes, dia] = this.solicitacao.parcelas[0].vencimento.split(
        "-"
      );
      const dataDeVencimentoFormatada = new Date();
      const DiaAtual = dia.split("T00:00:00.000");
      dataDeVencimentoFormatada.setDate(DiaAtual[0]);
      dataDeVencimentoFormatada.setMonth(mes - 1);
      dataDeVencimentoFormatada.setFullYear(ano);
      dataDeVencimentoFormatada.setHours(0, 0, 0, 0);

      let msgVencimento = "Atenção! Documento vencido, deseja continuar? \n (Antes de enviar ao financeiro contate seu fornecedor para negociar uma nova data de pagamento!)";
      let msgSispag =
        "Atenção! Pagamento fora do prazo de dois dias úteis antes do vencimento, deseja continuar? \n (Antes de enviar ao financeiro contate seu fornecedor para negociar uma nova data de pagamento!)";
      let msgPadrao =
        "Atenção! Pagamento fora do prazo de três dias úteis antes do vencimento, deseja continuar? \n (Antes de enviar ao financeiro contate seu fornecedor para negociar uma nova data de pagamento!)";

      if (
        dataDeVencimentoFormatada < today &&
        this.solicitacao.status !== "ENVIADO_PARA_ADM_FINANCEIRO"
      ) {
        this.dialogDueDateMessage = msgVencimento;
        this.solicitacao.excecao = true;
        this[dialogParaAbrir] = true;
        return true;
      } else if (
        this.solicitacao.formaDePagamento === "SISPAG" &&
        range < 2 &&
        this.solicitacao.status !== "ENVIADO_PARA_ADM_FINANCEIRO"
      ) {
        this.dialogDueDateMessage = msgSispag;
        this.solicitacao.excecao = true;
        this[dialogParaAbrir] = true;
        return true;
      } else if (
        this.solicitacao.formaDePagamento !== "SISPAG" &&
        range < 3 &&
        this.solicitacao.status !== "ENVIADO_PARA_ADM_FINANCEIRO"
      ) {
        this.solicitacao.excecao = true;
        this.dialogDueDateMessage = msgPadrao;
        this[dialogParaAbrir] = true;
        return true;
      } else {
        this.solicitacao.excecao = false;
        return false;
      }
    },
    mudouTipoDeDocumento(event) {
      let itemObrigatorio = this.tiposDeDocumentosNaoObrigatorios.indexOf(
        event
      );
      if (itemObrigatorio > -1) {
        this.numeroDoDocumentoAnterior = this.solicitacao.numeroDoDocumento;
        this.solicitacao.numeroDoDocumento = "";
      } else {
        if (this.solicitacao.numeroDoDocumento == "")
          this.solicitacao.numeroDoDocumento = this.numeroDoDocumentoAnterior;
      }
      this.$refs.primeiroForm.validate();
    },
    alterarCampoValorTotal(event, valor) {
      const valorTotal = this.solicitacao.valorTotal;

      const valorConvertido = conversor.methods.converterValorStringEmNumero(
        valorTotal,
        this.solicitacao.tipoDeMoeda
      );

      this.solicitacao.valorTotal = conversor.methods.converterParaMoedaReal(
        valorConvertido,
        this.solicitacao.tipoDeMoeda
      );
      this.gerarParcelas();
    },

    converterMoedasReal(valor, tipoDaMoeda) {
      const valorConvertido = conversor.methods.converterParaMoedaReal(
        valor,
        tipoDaMoeda
      );
      return valorConvertido;
    },

    getLodash: get,
    gerarParcelas(event) {
      this.solicitacao.parcelas = [];
      let valorTotal = this.solicitacao.valorTotal;
      if (valorTotal == null) valorTotal = 0;
      else
        valorTotal = conversor.methods.converterValorStringEmNumero(
          valorTotal,
          this.solicitacao.tipoDeMoeda
        );

      let divisao = valorTotal / this.parcelasSelecionadas;

      for (let i = 1; i <= this.parcelasSelecionadas; i++) {
        let valorDasParcelas = this.verificarValorDasParcelas(
          divisao,
          valorTotal,
          i
        );
        let parcela = {
          numero: i,
          valor: valorDasParcelas,
          vencimento: "",
        };
        this.solicitacao.parcelas.push(parcela);
      }
      this.validarTodasParcelas(this.validacaoDataDeVencimentoDasParcelas);
    },
    verificarValorDasParcelas(valorDaDivisao, valorTotal, indexDoLoop) {
      let diferenca =
        valorTotal -
        parseFloat(valorDaDivisao.toFixed(2)) * this.parcelasSelecionadas;
      if (diferenca > 0 && indexDoLoop == 1) {
        return `${conversor.methods.converterParaMoedaReal(
          parseFloat(valorDaDivisao.toFixed(2)) +
          parseFloat(diferenca.toFixed(2)),
          this.solicitacao.tipoDeMoeda
        )}`;
      } else if (diferenca < 0 && indexDoLoop == this.parcelasSelecionadas) {
        return `${conversor.methods.converterParaMoedaReal(
          parseFloat(valorDaDivisao.toFixed(2)) +
          parseFloat(diferenca.toFixed(2)),
          this.solicitacao.tipoDeMoeda
        )}`;
      } else {
        return `${conversor.methods.converterParaMoedaReal(
          valorDaDivisao.toFixed(2),
          this.solicitacao.tipoDeMoeda
        )}`;
      }
    },
    zerarParcelas() {
      this.parcelasSelecionadas = 1;
    },
    validarPrimeiraParcela(indexDaParcela) {
      for (let i = indexDaParcela + 1; i < this.parcelasSelecionadas; i++) {
        if (this.solicitacao.parcelas[i].vencimento != "") {
          if (
            moment(this.parcelaEditada.vencimento).isSameOrAfter(
              this.solicitacao.parcelas[i].vencimento
            )
          ) {
            return true;
          }
        }
      }
    },
    validarUltimaParcela(indexDaParcela) {
      for (let i = 0; i < this.parcelasSelecionadas; i++) {
        if (
          this.solicitacao.parcelas[i].vencimento != "" &&
          i != indexDaParcela
        ) {
          if (
            moment(this.parcelaEditada.vencimento).isSameOrBefore(
              this.solicitacao.parcelas[i].vencimento
            )
          ) {
            return true;
          }
        }
      }
    },
    validarParcelasDoMeio(indexDaParcela) {
      for (let i = 0; i < this.parcelasSelecionadas; i++) {
        if (
          i < indexDaParcela &&
          this.solicitacao.parcelas[i].vencimento != ""
        ) {
          if (
            moment(this.parcelaEditada.vencimento).isSameOrBefore(
              this.solicitacao.parcelas[i].vencimento
            )
          )
            return true;
        } else if (
          i > indexDaParcela &&
          this.solicitacao.parcelas[i].vencimento != ""
        ) {
          if (
            moment(this.parcelaEditada.vencimento).isSameOrAfter(
              this.solicitacao.parcelas[i].vencimento
            )
          )
            return true;
        }
      }
    },
    mudouForma(event) {
      if (event == "DEPÓSITO") {
        this.solicitacao.fornecedor.dadosBancarios.map((i, index) => {
          if (index == 0) i.selecionado = true;
          else i.selecionado = false;
        });
      }
      this.validarTodasParcelas(this.validacaoDataDeVencimentoDasParcelas);
    },
    selecionouConta(event, index) {
      for (
        let i = 0;
        i < this.solicitacao.fornecedor.dadosBancarios.length;
        i++
      ) {
        const element = this.solicitacao.fornecedor.dadosBancarios[i];
        if (i != index) element.selecionado = false;
      }
      this.solicitacao.fornecedor.dadosBancarios = [
        ...this.solicitacao.fornecedor.dadosBancarios,
      ];
    },
    async carregarDados(url) {
      return axios({
        method: "get",
        url: url,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.loggedUser.token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((s) => {
          return s;
        })
        .catch((e) => {
          return e;
        });
    },
    formataCorIntegracao(status) {
      if (status) {
        return "success--text";
      } else {
        return "error--text";
      }
    },
    recebeImpostos(event) {
      this.impostos[event.propriedade] = event.valor;
    },
    formataPagamentoLiberado(statusPagamento) {
      if (statusPagamento) {
        return "Pagamento para o fornecedor contendo este nº de pedido está liberado.";
      } else {
        return "Pagamento para o fornecedor contendo este nº de pedido não está liberado.";
      }
    },
    formataData(data) {
      let [ano, mes, dia] = data.split("T")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },
    configuraPermissaoParaEdicao() {
      let usuarioEhUmAprovador =
        this.loggedUser.papeis.filter(
          (papel) => papel.nome.indexOf("APROVADOR") != -1
        ).length > 0;

      let usuarioEhProcurador =
        this.loggedUser.papeis.filter(
          (papel) => papel.nome.indexOf("PROCURADOR") != -1
        ).length > 0 && this.solicitacao.status == "ENVIADO_PARA_PROCURADOR";

      let mesmoAprovador =
        this.solicitacao.usuarioAprovador.id == this.loggedUser.id;

      if (this.solicitacao.status == "ENVIADO_PARA_GESTOR" && mesmoAprovador)
        this.ehAprovador = true;
      else {
        if (
          (usuarioEhUmAprovador || usuarioEhProcurador) &&
          this.solicitacao.status != "ENVIADO_PARA_GESTOR"
        )
          this.ehAprovador = true;
      }
    },
    async enviarParaAprovacao(operacao) {

      let objEnvio = cloneDeep(this.solicitacao);
      objEnvio.numeroDoDocumento = substituirCaracteres(objEnvio.numeroDoDocumento, 0, 15);
      objEnvio.numeroDoPedido = substituirCaracteres(objEnvio.numeroDoPedido, 0, 30);
      this.dialogAprovador = false;
      this.loadingIsMakingRequest = true;

      this.tipoDeFornecedorEscolhido = this.verificaTipoDeFornecedor;

      this.snackbar.ativo = true;
      this.snackbar.color = "primary";
      this.snackbar.text = "Carregando...";
      objEnvio.fornecedor.endereco.pais = { sigla: "", id: "", nome: "" };
      let tipoEnvio = "put";
      if (objEnvio.id == null) {
        tipoEnvio = "post";
        objEnvio.fornecedorId = objEnvio.fornecedor.id;
        delete objEnvio.fornecedor;
        delete objEnvio.usuarioRegistrador;
      } else {
        this.approverIsValid = true;
      }

      if (this.$refs.formApprover.validate()) {
        this.loadingCreateRequest = true;

        objEnvio.usuarioRegistradorId = this.loggedUser.id;
        objEnvio.idAprovadorLog = this.loggedUser.id;

        switch (this.solicitacao.formaDePagamento) {
          case "DEPÓSITO":
            let contasSelecionadas = this.solicitacao.fornecedor.dadosBancarios.filter(
              (f) => {
                return f.selecionado == true;
              }
            );
            let contabancariaSelecionada = contasSelecionadas[0];
            objEnvio.pagamento.conta.id = contabancariaSelecionada.id;
            objEnvio.pagamento.banco = null;
            break;
          case "BOLETO":
            objEnvio.pagamento.conta.id = null;
            break;
          default:
            objEnvio.pagamento.conta.id = null;
            objEnvio.pagamento.banco = null;
            break;
        }

        let centrosDeCusto = objEnvio.rateios;
        objEnvio.rateios = [];
        centrosDeCusto.map((centro) => {
          let centroFormatado = {
            departamento: {
              id: centro.departamento.id,
            },
            contaGerencial: {
              id: centro.contaGerencial.id,
            },
            valor: centro.valor,
          };
          objEnvio.rateios.push(centroFormatado);
        });

        objEnvio.valorTotal = parseFloat(
          conversor.methods.converterValorStringEmNumero(
            this.solicitacao.valorTotal,
            this.solicitacao.tipoDeMoeda
          )
        );

        objEnvio.parcelas.map(
          (i) =>
          (i.valor = Number(
            conversor.methods.converterValorStringEmNumero(
              i.valor,
              this.solicitacao.tipoDeMoeda
            )
          ))
        );

        objEnvio.usuarioAprovadorId = this.aprovadorSelecionado;
        objEnvio.idAprovadorLog = this.loggedUser.id;

        if (operacao == "ENVIAR_PARA_APROVACAO" && objEnvio.id != null) {
          objEnvio.usuarioAprovador.id = this.aprovadorSelecionado;
        }

        objEnvio.rateios.map((item) => {
          item.valor = parseFloat(item.valor).toFixed(2);
        });

        if (operacao === "APROVAR") {
          this.dialogConfirmarAprovacao = false;
        }

        if (operacao === "REPROVAR") {
          this.dialogConfirmarReprovacao = false;
          if (objEnvio.motivo != null) {
            if (this.motivoDaReprovacao != "")
              objEnvio.motivo =
                objEnvio.motivo + "\n" + this.motivoDaReprovacao;
          } else objEnvio.motivo = this.motivoDaReprovacao;
        }
        objEnvio.status = await this.retornarStatus(operacao);

        Object.keys(this.impostos).map((i) => {
          if (isNaN(this.impostos[i])) {
            if (this.impostos[i].indexOf("-") != -1) {
              this.impostos[i] = this.impostos[i]
                .replace("-", "")
                .replace(/\s/g, "");
              this.impostos[i] = conversor.methods.converterValorStringEmNumero(
                this.impostos[i],
                this.solicitacao.tipoDeMoeda
              );
              this.impostos[i] = "-" + this.impostos[i];
              this.impostos[i] = Number(this.impostos[i]);
            } else {
              this.impostos[i] = Number(
                conversor.methods.converterValorStringEmNumero(
                  this.impostos[i],
                  this.solicitacao.tipoDeMoeda
                )
              );
            }
          }
        });
        objEnvio.impostos = this.impostos;
        try {
          this.snackbar.ativo = true;
          let vm = this;

          try {
            const responseCreateRequest = await axios({
              method: tipoEnvio,
              url: `/solicitacoes`,
              responseType: "json",
              headers: {
                Authorization: `Bearer ${this.loggedUser.token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              data: JSON.stringify(objEnvio),
            });

            this.snackbar.ativo = false;
            this.snackbar.ativo = true;
            this.snackbar.color = "primary";
            this.snackbar.text = "Enviando anexo...";

            if (this.files.length > 0) {
              const anexosFormData = this.converterAnexosEmFormData();
              const idPedido = responseCreateRequest.data.id;
              this.salvarAnexos(idPedido, anexosFormData)
            }

            this.dialogAprovador = false;
            let vm = this;
            vm.snackbar.ativo = false;
            vm.snackbar.ativo = true;
            vm.snackbar.color = "success";
            vm.snackbar.text = "Pedido enviado com sucesso!";
            setTimeout(function () {
              vm.$router.push({ name: `solicitacoes` });
            }, 1000);
            this.loadingCreateRequest = false;
          } catch (e) {
            this.snackbar.color = "error";
            this.snackbar.text = `Houve um erro na criação do pedido. Erro: ${e}. Para mais informações entre em contato com o Administrador.`;
            this.snackbar.ativo = true;
            this.loadingIsMakingRequest = false;
            this.loadingCreateRequest = false;
          }
        } catch (erro) {
          this.snackbar.color = "error";
          this.snackbar.text = `Houve um erro na criação do pedido. Código do erro: ${erro.response.data.status}. Para mais informações entre em contato com o Administrador.`;
          this.snackbar.ativo = true;

          this.loadingIsMakingRequest = false;
          this.loadingCreateRequest = false;
        }
      }
    },
    retornarStatus(operacao) {
      // solicitante
      if (
        operacao === "ENVIAR_PARA_APROVACAO" &&
        this.loggedUser.papeis.filter((papel) => papel.nome === "SOLICITANTE")
          .length > 0
      ) {
        return "ENVIADO_PARA_GESTOR";
      }

      // aprovadores
      if (operacao === "APROVAR") {
        if (
          this.loggedUser.papeis.filter((papel) => papel.nome === "APROVADOR")
            .length > 0 &&
          this.solicitacao.status === "ENVIADO_PARA_GESTOR"
        ) {
          if (this.solicitacao.fornecedor.status == "EM_ANALISE") {
            return "ENVIADO_PARA_ADM_FORNECEDOR";
          } else {
            if (this.solicitacao.excecao) return "ENVIADO_PARA_ADM_FINANCEIRO";
            else return "ENVIADO_PARA_FINANCEIRO";
          }
        }

        if (
          this.loggedUser.papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO"
          ).length > 0 &&
          this.solicitacao.status === "ENVIADO_PARA_ADM_FINANCEIRO"
        ) {
          this.solicitacao.excecao = true;
          return "ENVIADO_PARA_FINANCEIRO";
        }

        if (
          this.loggedUser.papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          this.solicitacao.status === "ENVIADO_PARA_FINANCEIRO"
        ) {
          return "ENVIADO_PARA_CONTABILIDADE";
        }

        if (
          this.loggedUser.papeis.filter(
            (papel) => papel.nome === "ADMIN_FORNECEDOR"
          ).length > 0 &&
          this.solicitacao.status === "ENVIADO_PARA_ADM_FORNECEDOR"
        ) {
          return "ENVIADO_PARA_FINANCEIRO";
        }

        if (
          this.loggedUser.papeis.filter(
            (papel) => papel.nome === "APROVADOR_CONTABILIDADE"
          ).length > 0 &&
          this.solicitacao.status === "ENVIADO_PARA_CONTABILIDADE"
        ) {
          return "ENVIADO_PARA_PROCURADOR";
        }

        if (
          this.loggedUser.papeis.filter((papel) => papel.nome === "PROCURADOR")
            .length > 0 &&
          this.solicitacao.status === "ENVIADO_PARA_PROCURADOR"
        ) {
          return "APROVADO_PELO_PROCURADOR";
        }
      }

      // reprovadores
      if (operacao === "REPROVAR") {
        if (
          this.loggedUser.papeis.filter((papel) => papel.nome === "APROVADOR")
            .length > 0 &&
          this.solicitacao.status === "ENVIADO_PARA_GESTOR"
        ) {
          return "REPROVADO_PELO_GESTOR";
        }

        if (
          this.loggedUser.papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          (this.solicitacao.status === "ENVIADO_PARA_FINANCEIRO" ||
            this.solicitacao.status === "REPROVADO_PELO_PROCURADOR")
        ) {
          return "REPROVADO_PELO_FINANCEIRO";
        }

        if (
          this.loggedUser.papeis.filter(
            (papel) => papel.nome === "APROVADOR_CONTABILIDADE"
          ).length > 0 &&
          this.solicitacao.status === "ENVIADO_PARA_CONTABILIDADE"
        ) {
          return "REPROVADO_PELA_CONTABILIDADE";
        }

        if (
          this.loggedUser.papeis.filter((papel) => papel.nome === "PROCURADOR")
            .length > 0 &&
          this.solicitacao.status === "ENVIADO_PARA_PROCURADOR"
        ) {
          return "REPROVADO_PELO_PROCURADOR";
        }

        if (
          this.loggedUser.papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          this.solicitacao.status === "APROVADO_PELO_PROCURADOR"
        ) {
          return "REPROVADO_PELO_PROCURADOR";
        }

        if (
          this.loggedUser.papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO"
          ).length > 0 &&
          this.solicitacao.status === "ENVIADO_PARA_ADM_FINANCEIRO"
        ) {
          return "REPROVADO_PELO_ADM_FINANCEIRO";
        }

        if (
          this.loggedUser.papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          this.solicitacao.status === "REPROVADO_PELO_PROCURADOR"
        ) {
          return "REPROVADO_PELO_FINANCEIRO";
        }
      }
      return operacao;
    },
    verificaTipoDeFornecedor() {
      if (this.solicitacao.fornecedor.cnpj) {
        return "Pessoa Jurídica";
      } else if (this.solicitacao.fornecedor.cpf) {
        return "Pessoa Física";
      } else {
        return "Estrangeiro";
      }
    },
    calculaRangeDeData(data) {
      const dataFormatada = moment(data);
      const hoje = moment().startOf("day");
      const range = business.weekDays(hoje, dataFormatada);
      const feriado = feriados(data, 3);
      let diaFinal = range + feriado;
      return diaFinal;
    },
    async openApproverDialog() {
      this.dialogAprovador = true;
      this.loadingApprovers = true;

      await this.carregarDados(
        `/usuarios/${this.loggedUser.id}/papel/APROVADOR`
      ).then((response) => {
        this.aprovadores = response.data;
        this.loadingApprovers = false;
      });
      this.loadingApprovers = false;
      this.loadingApprovers = true;
      setTimeout(() => {
        this.loadingApprovers = false;
      }, 1000);
      this.dialogAprovador = true;
    },
    findWhichDialogToOpen() {
      if (
        !this.desabilitarPorTipoDeDocumento &&
        this.solicitacao.numeroDoDocumento == ""
      ) {
        this.$store.commit(
          "snackErro",
          "Número do documento obrigatório para o tipo de documento selecionado."
        );
        return;
      }

      if (this.modoVisualizacao) {
        let pedidoEhExcecao = this.retornaExcecao("dialogDueDate");
        if (!pedidoEhExcecao) {
          this.dialogDueDateMessage = null;
          if (this.solicitacao.status.includes("REPROVADO")) {
            this.openApproverDialog();
          } else {
            this.enviarParaAprovacao("APROVAR");
          }
        }
        return;
      }

      let pedidoEhExcecao = this.retornaExcecao("dialogDueDate");
      if (!pedidoEhExcecao) {
        this.dialogDueDateMessage = null;
        this.openApproverDialog();
      }
    },
    deletarItem() {
      const index = this.nomeDoArray.indexOf(this.itemDeletado);
      this.nomeDoArray.splice(index, 1);
      this.fecharDialogDelete();
    },
    abrirDialogDelete(itemDeletado, nomeDoArray) {
      this.dialogConfirmar = true;
      this.itemDeletado = itemDeletado;
      this.nomeDoArray = nomeDoArray;
    },
    fecharDialogDelete() {
      this.itemDeletado = {};
      this.dialogConfirmar = false;
    },
    close({ dialogName, formName, itemName, defaultItemName } = {}) {
      this[dialogName] = false;
      setTimeout(() => {
        this[itemName] = Object.assign({}, this[defaultItemName]);
        this.$refs[formName].reset();
      }, 300);
    },
    handleFilesUpload(nameOfVariableAndRef) {
      let arquivos = this.$refs[nameOfVariableAndRef].files;
      let foiValidado = true;
      let nomeDoArquivo = "";
      let erroMsg = "";
      let somaNovosArquivos = 0;
      let somaTamanhoTotal = 0;

      for (let index = 0; index < arquivos.length; index++) {
        const itemArray = arquivos[index];
        if (itemArray.size >= 50000000) {
          nomeDoArquivo = itemArray.name;
          erroMsg = `O arquivo ${nomeDoArquivo} ultrapassou o tamanho máximo de 50MB de anexos.`;
          foiValidado = false;
          break;
        }
        somaNovosArquivos += itemArray.size;
      }

      for (let index = 0; index < this[nameOfVariableAndRef].length; index++) {
        somaTamanhoTotal += this[nameOfVariableAndRef][index].size;
      }
      if (somaNovosArquivos + somaTamanhoTotal >= 50000000) {
        erroMsg = `Limite máximo de anexo excedido. Permitido no máximo até 50MB.`;
        foiValidado = false;
      }
      if (foiValidado) {
        this[nameOfVariableAndRef] = [
          ...this[nameOfVariableAndRef],
          ...arquivos,
        ];
        this.msgErroAnexo = "";
      } else this.msgErroAnexo = erroMsg;
    },
    enviarArquivoClique() {
      this.$refs.files.click();
    },
    formataStatus(statusRecebido) {
      switch (statusRecebido) {
        case "EM_ANALISE":
          return "Em Análise";
        case "APROVADO":
          return "Aprovado";
      }
    },
    async getContasGerenciaisPorEmpresa(idDaEmpresa) {
      this.contasGerenciaisPorEmpresa = [];
      await this.carregarDados(`/contasgerenciais/empresa/${idDaEmpresa}`)
        .then((dadosCompletos) => {
          this.contasGerenciaisPorEmpresa = dadosCompletos.data;
          this.$store.commit("set", {
            itemName: "contasGerenciais",
            content: dadosCompletos.data,
          });
        })
        .catch((e) => {
          this.contasGerenciaisPorEmpresa = [];
          this.$store.commit("set", {
            itemName: "contasGerenciais",
            content: [],
          });
        });
    },
    async getCentrosDeCustosPorEmpresa(idDaEmpresa) {
      this.departamentosDoCentroDeCusto = [];
      this.loadingManagementAccountDepartments = true;
      await this.carregarDados(`/centrosdecustos/empresas/${idDaEmpresa}`)
        .then((dadosCompletos) => {
          this.departamentosDoCentroDeCusto = dadosCompletos.data;
          this.$store.commit("set", {
            itemName: "centroDeCustos",
            content: dadosCompletos.data,
          });
        })
        .catch((e) => {
          this.departamentosDoCentroDeCusto = [];
        })
        .finally((s) => (this.loadingManagementAccountDepartments = false));
    },
    formataValorRateio(eventoBlur) {
      const converteNumero = conversor.methods.converterValorStringEmNumero(
        eventoBlur.target.value,
        this.solicitacao.tipoDeMoeda
      );
      this.valorDoCentroDeCusto = conversor.methods.converterParaMoedaReal(
        converteNumero,
        this.solicitacao.tipoDeMoeda
      );
    },
    adicionarCentroDeCusto() {
      let numero = conversor.methods.converterValorStringEmNumero(
        this.valorDoCentroDeCusto,
        this.solicitacao.tipoDeMoeda
      );
      this.valorDoCentroDeCusto = parseFloat(numero);

      if (this.editedCenterIndex > -1) {
        let { nome, centroDeCusto, id, numero } = this.editedCostCenter;
        let objEdit;
        objEdit = {
          contaGerencial: this.contaGerencialSelecionada,
          departamento: {
            nome,
            id,
            centroDeCusto,
          },
          valor: this.valorDoCentroDeCusto,
        };
        Object.assign(
          this.solicitacao.rateios[this.editedCenterIndex],
          objEdit
        );
      } else {
        let { nome, centroDeCusto, id } = this.editedCostCenter;
        this.solicitacao.rateios.push({
          contaGerencial: this.contaGerencialSelecionada,
          departamento: {
            nome,
            id,
            centroDeCusto,
          },
          valor: this.valorDoCentroDeCusto,
        });
      }

      this.valorDoCentroDeCusto = null;
      this.contaGerencialSelecionada = {};
      this.loadingContaGerencial = false;
      this.close({
        dialogName: "dialogCentro",
        formName: "formCentros",
        itemName: "editedCostCenter",
        defaultItemName: "defaultItemName",
      });
    },
    async editarCentroDeCusto(centroDeCusto) {
      this.editedCenterIndex = this.solicitacao.rateios.indexOf(centroDeCusto);
      this.editedCostCenter = centroDeCusto.departamento;
      this.contaGerencialSelecionada = centroDeCusto.contaGerencial;

      let numero = conversor.methods.converterParaMoedaReal(
        centroDeCusto.valor,
        this.solicitacao.tipoDeMoeda
      );

      this.valorDoCentroDeCusto = numero;
      this.dialogCentro = true;
    },
    dadosRecebidos(meuItem) {
      meuItem.map((cadaItem) => {
        this.solicitacao.rateios.push(cadaItem);
      });
    },
    converterParaMoedaReal(numero) {
      let formatter;
      if (this.solicitacao.tipoDeMoeda == "USD") {
        formatter = this.converterOutrasMoedas("en-US", "currency", "USD");
      } else if (this.solicitacao.tipoDeMoeda == "AUD") {
        formatter = this.converterOutrasMoedas("en-au", "currency", "AUD");
      } else if (this.solicitacao.tipoDeMoeda == "CAD") {
        formatter = this.converterOutrasMoedas("en-ca", "currency", "CAD");
      } else if (this.solicitacao.tipoDeMoeda == "JPY") {
        formatter = this.converterOutrasMoedas("ja", "currency", "JPY");
      } else if (this.solicitacao.tipoDeMoeda == "EUR") {
        formatter = this.converterOutrasMoedas("fr", "currency", "EUR");
      } else if (this.solicitacao.tipoDeMoeda == "GBP") {
        formatter = this.converterOutrasMoedas("en-gb", "currency", "GBP");
      } else if (this.solicitacao.tipoDeMoeda == "SGD") {
        formatter = this.converterOutrasMoedas("zh-sg", "currency", "SGD");
      } else if (this.solicitacao.tipoDeMoeda == "MXN") {
        formatter = this.converterOutrasMoedas("es-mx", "currency", "MXN");
      } else formatter = this.converterOutrasMoedas("pt-BR", "currency", "BRL");
      return formatter.format(numero);
    },

    formatarValorTotalDoPagamento(eventoBlur) {
      const valorConvertido = conversor.methods.converterValorStringEmNumero(
        eventoBlur.target.value,
        this.solicitacao.tipoDeMoeda
      );

      this.solicitacao.valorTotal = conversor.methods.converterParaMoedaReal(
        valorConvertido,
        this.solicitacao.tipoDeMoeda
      );
      if (eventoBlur.target.value != this.solicitacao.valorTotal) {
        this.solicitacao.parcelas[0].valor = this.solicitacao.valorTotal;
        this.zerarParcelas();
      }
    },
    converterOutrasMoedas(linguagem, estilo, pais) {
      return new Intl.NumberFormat(linguagem, {
        style: estilo,
        currency: pais,
        minimumFractionDigits: 2,
      });
    },
    converterValorStringEmNumero(valor) {
      if (typeof valor !== "string") return valor;
      valor = valor
        .replace("R$", "")
        .replace("$", "")
        .replace("￥", "")
        .replace("€", "")
        .replace("£", "")
        .replace("S$", "")
        .replace("Mex$", "");
      if (this.solicitacao.tipoDeMoeda.indexOf("BRL") != -1) {
        valor = valor.replace(/\./g, "");
        valor = valor.replace(",", ".");
      } else if (this.solicitacao.tipoDeMoeda.indexOf("EUR") != -1) {
        valor = valor.replace(/\s/g, "");
        valor = valor.replace(",", ".");
      } else {
        valor = valor.replace(/\,/g, "");
      }
      if (isNaN(valor)) {
        valor = 0;
        return valor;
      }
      return valor;
    },
    podeVer() {
      let idDoUsuario = this.loggedUser.id;
      let papeis = this.loggedUser.papeis;
      let solicitacao = this.solicitacao;
      if (idDoUsuario != solicitacao.usuarioRegistrador.id) {
        if (
          (papeis.filter((papel) => papel.nome === "APROVADOR").length > 0 &&
            solicitacao.status === "ENVIADO_PARA_GESTOR") ||
          (papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO"
          ).length > 0 &&
            solicitacao.status === "ENVIADO_PARA_ADM_FINANCEIRO") ||
          (papeis.filter((papel) => papel.nome === "APROVADOR_FINANCEIRO")
            .length > 0 &&
            solicitacao.status === "ENVIADO_PARA_FINANCEIRO") ||
          (papeis.filter((papel) => papel.nome === "APROVADOR_CONTABILIDADE")
            .length > 0 &&
            solicitacao.status === "ENVIADO_PARA_CONTABILIDADE")
        ) {
          return true;
        } else return false;
      } else return false;
    },
    async buscarDadosBancarios() {
      this.loadingProviderData = true;
      let cnpjOuCpf = this.contemNumero(this.solicitacao.CnpjOuCpfOuNome)
      let numeroDocumento = ""
      if(cnpjOuCpf){
        numeroDocumento = this.solicitacao.CnpjOuCpfOuNome
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "");
      } else {
        numeroDocumento = this.solicitacao.CnpjOuCpfOuNome
      }

      await this.carregarDados(
        `/fornecedores/busca?fornecedor=${numeroDocumento}`
      )
        .then((dadosCompletos) => {
          dadosCompletos.data.dadosBancarios = dadosCompletos.data.dadosBancarios.filter(
            (f) => f.estaAtivo
          );
          dadosCompletos.data.dadosBancarios.map((i, index) => {
            if (index == 0) i.selecionado = true;
            else i.selecionado = false;
          });
          this.solicitacao.fornecedor = dadosCompletos.data;
          this.loadingProviderData = false;
          this.fornecedorFoiValido = true;
          this.dadosCompletosDoFornecedor = dadosCompletos.data;
        })
        .catch((error) => {
          this.fornecedorFoiValido = false;
          this.solicitacao.fornecedor = {
            id: null,
            endereco: {
              logradouro: null,
              pais: {
                nome: null,
              },
            },
            dadosBancarios: [],
          };
          this.loadingProviderData = false;
          this.loadingManagementAccountDepartments = false;
        });
    },
    retornaIdDoFornecedor(forn) {
      if (forn.tipo.toLowerCase() == "fornecedorjuridico") return forn.cnpj;
      if (forn.tipo.toLowerCase() == "fornecedorfisico") return forn.cpf;
      if (forn.tipo.toLowerCase() == "fornecedorestrangeiro") return forn.nome;
    },
    validarSeParcelasForamPreenchidas() {
      for (let i = 0; i < this.solicitacao.parcelas.length; i++) {
        if (this.solicitacao.parcelas[i].vencimento.length < 8) {
          return false
        }
      }
    },
    validarTodasParcelas(statusValidacaoParcelas) {
      var estaoTodasPreenchidas = this.validarSeParcelasForamPreenchidas();
      if (estaoTodasPreenchidas == undefined) estaoTodasPreenchidas = true;
      if (estaoTodasPreenchidas && statusValidacaoParcelas) this.parcelasValidadas = true;
      else this.parcelasValidadas = false;
    },
    async salvarAnexos(idPedido, anexos) {
      console.log('------SALVANDO ANEXO------')
      await axios({
        method: "post",
          url: `/uploads/solicitacoes/${idPedido}/tipo/SOLICITACAO`,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: anexos,
        })
        .then(() => console.log('ANEXO SALVO COM SUCESSO'))
        .catch((erro) => {
          console.log('------ERRO DE ANEXO ABAIXO------')
          console.log(erro)
          console.log(erro.response)
        })
    },
    converterAnexosEmFormData() {
      let formData = new FormData();
      for (let i = 0; i < this.files.length; i++) {
        formData.append("arquivos", this.files[i]);
      }
      return formData;
    },
    contemNumero(minhaString) {
      return /\d/.test(minhaString);
    }
  },
  async created() {
    await this.$store.dispatch("get", {
      loaderName: "loadingCompanies",
      service: "/empresas",
      itemName: "empresas",
    });

    if (this.$route.params.id !== undefined) {
      await this.carregarDados(`/solicitacoes/${this.$route.params.id}`).then(
        (s) => {
          const usuariosDoPedido = {
            idAprovador: s.data.usuarioAprovador.id,
            idRegistrador: s.data.usuarioRegistrador.id
          }
          if (validarSeUsuarioLogadoPodeVerPedido(usuariosDoPedido)) {
            let d = s.data;
            this.solicitacao = d;
            if (this.solicitacao.logs && this.solicitacao.logs.length > 0) {
              this.solicitacao.logs = this.solicitacao.logs.map(log => converterLogParaHorarioDeSaoPaulo(log));
            }

            this.impostos = this.solicitacao.impostos;
            delete this.impostos.id;

            Object.keys(this.impostos).map((i) => {
              this.impostos[i] = conversor.methods.converterParaMoedaReal(
                this.impostos[i],
                this.solicitacao.tipoDeMoeda
              );
            });

            // this.solicitacao.empresaId = d.empresa.id;
            this.solicitacao.CnpjOuCpfOuNome = this.retornaIdDoFornecedor(
              d.fornecedor
            );
            this.fornecedorFoiValido = true;

            if (this.solicitacao.formaDePagamento == "DEPÓSITO") {
              this.solicitacao.fornecedor.dadosBancarios = this.solicitacao.fornecedor.dadosBancarios.filter(
                (i) => i.estaAtivo
              );

              this.solicitacao.fornecedor.dadosBancarios.map((c) => {
                if (c.id == this.solicitacao.pagamento.conta.id)
                  c.selecionado = true;
                else c.selecionado = false;
              });
            }

            this.parcelasSelecionadas = this.solicitacao.parcelas.length;

            this.solicitacao.dataDeEmissaoDoDocumento = new Date(
              this.solicitacao.dataDeEmissaoDoDocumento
            )
              .toISOString()
              .split("T")[0];
            this.solicitacao.parcelas[0].vencimento = new Date(
              this.solicitacao.parcelas[0].vencimento
            )
              .toISOString()
              .split("T")[0];
            this.aprovadorSelecionado = this.solicitacao.usuarioAprovador.id;
            this.modoVisualizacao = true;

            this.solicitacao.valorTotal = conversor.methods.converterParaMoedaReal(
              this.solicitacao.valorTotal,
              this.solicitacao.tipoDeMoeda
            );

            if (this.verificarPraEditar) {
              this.todosRateios = this.solicitacao.rateios;
            }

            if (this.verificaPerfilFinanceiro) {
              let numeroDoPedidoCorreto = {
                $event: this.solicitacao.numeroDoPedido,
              };
              this.novoDebounceValidacao(numeroDoPedidoCorreto);
            }

            this.dadosCompletosDoFornecedor = this.solicitacao.fornecedor;
            this.configuraPermissaoParaEdicao();
          }
        }
      );
      this.parcelasValidadas = true;
    }
  },
  computed: {
    parcelas() {
      let parcelas = [];
      let valorTotal = this.solicitacao.valorTotal;
      if (valorTotal == null) valorTotal = 0;
      else
        valorTotal = conversor.methods.converterValorStringEmNumero(
          valorTotal,
          this.solicitacao.tipoDeMoeda
        );
      for (let i = 1; i < 13; i++) {
        let divisao = valorTotal / i;
        let parcela = {
          texto: `${i}x de ${conversor.methods.converterParaMoedaReal(
            divisao.toFixed(2),
            this.solicitacao.tipoDeMoeda
          )}`,
          valor: i,
        };
        parcelas.push(parcela);
      }
      return parcelas;
    },
    financeiroVerNoPago() {
      let usuarioEhFinanceiro =
        this.loggedUser.papeis.filter(
          (papel) => papel.nome == "APROVADOR_FINANCEIRO"
        ).length > 0;
      if (
        usuarioEhFinanceiro &&
        this.solicitacao.status == "APROVADO_PELO_PROCURADOR"
      )
        return true;
      else return false;
    },
    retornaTextoCorretoParaFinanceiro() {
      if (this.solicitacao.status == "REPROVADO_PELO_PROCURADOR")
        return "Para quem deseja enviar?";
      else return "Confirmar aprovação do pedido?";
    },
    mostrarImpostos() {
      let usuarioApenasSolicitante =
        this.loggedUser.papeis.filter((papel) => papel.nome == "SOLICITANTE")
          .length > 0;
      let unicoPapel = this.loggedUser.papeis.length == 1;
      if (usuarioApenasSolicitante && unicoPapel) return false;
      else return true;
    },
    aprovadorCorreto() {
      return (
        (this.getLodash(this.solicitacao, "usuarioAprovador.id", null) ===
          this.loggedUser.id &&
          this.solicitacao.status === "ENVIADO_PARA_GESTOR") ||
        (this.loggedUser.papeis.filter(
          (papel) => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO"
        ).length > 0 &&
          this.solicitacao.status === "ENVIADO_PARA_ADM_FINANCEIRO") ||
        (this.loggedUser.papeis.filter(
          (papel) => papel.nome === "APROVADOR_FINANCEIRO"
        ).length > 0 &&
          this.solicitacao.status === "ENVIADO_PARA_FINANCEIRO") ||
        (this.loggedUser.papeis.filter(
          (papel) => papel.nome === "APROVADOR_CONTABILIDADE"
        ).length > 0 &&
          this.solicitacao.status === "ENVIADO_PARA_CONTABILIDADE") ||
        (this.loggedUser.papeis.filter((papel) => papel.nome === "PROCURADOR")
          .length > 0 &&
          this.solicitacao.status === "ENVIADO_PARA_PROCURADOR") ||
        (this.loggedUser.papeis.filter(
          (papel) => papel.nome === "APROVADOR_FINANCEIRO"
        ).length > 0 &&
          this.solicitacao.status === "REPROVADO_PELO_PROCURADOR")
      );
    },
    retornaListaCorretaRateios() {
      if (this.verificarPraEditar) return [this.solicitacao.rateios[0]];
      else return this.solicitacao.rateios;
    },
    verificaPerfilJuridico() {
      let ehJuridico = this.solicitacao.fornecedor.tipo == "FornecedorJuridico";
      if (ehJuridico) return true;
      else if (
        ehJuridico == false &&
        this.solicitacao.mensagemIntegracao != null
      ) {
        return true;
      } else return false;
    },
    verificaPerfilFinanceiro() {
      if (
        this.loggedUser.papeis.filter(
          (papel) => papel.nome === "APROVADOR_FINANCEIRO"
        ).length != 0 &&
        this.solicitacao.status == "ENVIADO_PARA_FINANCEIRO"
      ) {
        return true;
      } else return false;
    },
    podeVisualizar() {
      let idDoUsuario = this.loggedUser.id;
      let papeis = this.loggedUser.papeis;
      let solicitacao = this.solicitacao;

      if (idDoUsuario != solicitacao.idDoSolicitante) {
        if (
          papeis.filter((papel) => papel.nome === "APROVADOR").length > 0 &&
          solicitacao.status === "ENVIADO_PARA_GESTOR"
        ) {
          return true;
        } else if (
          papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO"
          ).length > 0 &&
          solicitacao.status === "ENVIADO_PARA_ADM_FINANCEIRO"
        ) {
          return true;
        } else if (
          papeis.filter((papel) => papel.nome === "APROVADOR_FINANCEIRO")
            .length > 0 &&
          solicitacao.status === "ENVIADO_PARA_FINANCEIRO"
        ) {
          return true;
        } else if (
          papeis.filter((papel) => papel.nome === "APROVADOR_CONTABILIDADE")
            .length > 0 &&
          solicitacao.status === "ENVIADO_PARA_CONTABILIDADE"
        ) {
          return true;
        } else if (
          papeis.filter((papel) => papel.nome === "PROCURADOR").length > 0 &&
          solicitacao.status === "ENVIADO_PARA_PROCURADOR"
        )
          return true;
        else if (
          papeis.filter((papel) => papel.nome === "APROVADOR_FINANCEIRO")
            .length > 0 &&
          solicitacao.status === "REPROVADO_PELO_PROCURADOR"
        )
          return true;
        else return false;
      } else {
        if (
          (papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO"
          ).length > 0 &&
            solicitacao.status === "ENVIADO_PARA_ADM_FINANCEIRO") ||
          (papeis.filter((papel) => papel.nome === "APROVADOR_FINANCEIRO")
            .length > 0 &&
            solicitacao.status === "ENVIADO_PARA_FINANCEIRO") ||
          (papeis.filter((papel) => papel.nome === "APROVADOR_CONTABILIDADE")
            .length > 0 &&
            solicitacao.status === "ENVIADO_PARA_CONTABILIDADE") ||
          (papeis.filter((papel) => papel.nome === "PROCURADOR").length > 0 &&
            solicitacao.status === "ENVIADO_PARA_PROCURADOR")
        ) {
          return true;
        }

        return false;
      }
    },
    headersProvider() {
      return [
        { text: "Selecionar", value: "", sortable: false },
        { text: "Banco", value: "banco", sortable: false },
        {
          text: "Agência",
          value: "agencia",
          align: "left",
          sortable: false,
        },
        { text: "Conta", value: "conta", align: "left", sortable: false },
      ];
    },
    msgAprovadorNaoEncontrado() {
      if (this.aprovadorSelecionado === null) {
        return "Carregando aprovadores";
      } else if (this.loadingApprovers) {
        return "Carregando lista de aprovadores...";
      } else if (get(this.aprovadores, "content", []).length === 0) {
        return "Nenhum aprovador cadastrado no seu departamento";
      } else {
        return "Não encontramos um aprovador com estes dados.";
      }
    },
    verificarSaldoTotal() {
      const calculaValorTotal = conversor.methods.converterParaMoedaReal(
        this.calculaValorTotal,
        this.solicitacao.tipoDeMoeda
      );

      let valorPraComparar = conversor.methods.converterValorStringEmNumero(
        calculaValorTotal,
        this.solicitacao.tipoDeMoeda
      );

      if (valorPraComparar <= 0) {
        return false;
      } else {
        return true;
      }
    },
    calculaValorTotal() {
      let valorPagamento = this.solicitacao.valorTotal;
      if (this.solicitacao.rateios.length === 0) {
        if (isNaN(valorPagamento))
          valorPagamento = conversor.methods.converterValorStringEmNumero(
            valorPagamento,
            this.solicitacao.tipoDeMoeda
          );

        return valorPagamento;
      }

      let valorTotalDosCentrosDeCusto = 0;
      this.solicitacao.rateios.map((centro) => {
        valorTotalDosCentrosDeCusto += parseFloat(centro.valor);
      });
      if (
        this.solicitacao.valorTotal === null ||
        this.solicitacao.valorTotal === ""
      ) {
        return "Valor total vazio ou incorreto";
      } else {
        return (
          Number(
            conversor.methods.converterValorStringEmNumero(
              this.solicitacao.valorTotal,
              this.solicitacao.tipoDeMoeda
            )
          ) - Number(valorTotalDosCentrosDeCusto.toFixed(2))
        );
      }
    },
    textoDoBotaoDoForm() {
      return this.editedCenterIndex === -1 ? "Adicionar" : "Atualizar";
    },
    msgDepartamentoNaoEncontrado() {
      if (this.contaGerencialSelecionada === null) {
        return "Selecione uma conta gerencial.";
      } else if (this.loadingManagementAccountDepartments) {
        return "Carregando centros de custo...";
      } else if (get(this.departamentos, "content", []).length === 0) {
        return "Nenhum centro de custo cadastrado para esta conta gerencial.";
      } else {
        return "Não encontramos um centro de custo com este nome de departamento ou número.";
      }
    },
    msgContaGerencialNaoEncontrada() {
      return get(this.contasGerenciais, "content", []).length === 0
        ? "Nenhuma conta gerencial cadastrada"
        : "Não encontramos um centro de custo este nome de departamento ou número.";
    },
    tituloDoForm() {
      return this.editedCenterIndex === -1
        ? "Adicionar Centro de Custo"
        : "Atualizar Centro de Custo";
    },
    rateioValido() {
      if (
        this.solicitacao.empresaId == null ||
        this.calcularValorTotal == 0 ||
        this.calcularValorTotal == "0"
      ) {
        return true;
      } else return false;
    },
    calcularValorTotal() {
      let valorPagamento = this.solicitacao.valorTotal;
      if (this.solicitacao.rateios.length === 0) {
        if (isNaN(valorPagamento)) {
          valorPagamento = conversor.methods.converterValorStringEmNumero(
            valorPagamento,
            this.solicitacao.tipoDeMoeda
          );
        }
        return valorPagamento;
      }
      let valorTotalDosCentrosDeCusto = 0;
      this.solicitacao.rateios.map((centro) => {
        valorTotalDosCentrosDeCusto += parseFloat(centro.valor);
      });
      if (
        this.solicitacao.valorTotal === null ||
        this.solicitacao.valorTotal === ""
      ) {
        return "Valor total vazio ou incorreto";
      } else {
        return (
          Number(
            conversor.methods.converterValorStringEmNumero(
              this.solicitacao.valorTotal,
              this.solicitacao.tipoDeMoeda
            )
          ) - Number(valorTotalDosCentrosDeCusto.toFixed(2))
        );
      }
    },
    verificarPraEditar() {
      let estaReprovado =
        this.solicitacao.status.includes("REPROVADO") &&
        this.solicitacao.status != "REPROVADO_PELO_PROCURADOR";
      let usuarioDoPedido = this.solicitacao.usuarioRegistrador.id;
      if (estaReprovado) {
        if (usuarioDoPedido == this.loggedUser.id) return false;
        else return true;
      } else {
        if (this.solicitacao.status == "") return false;
        else return true;
      }
    },
    tiposDeDocumentosNaoObrigatorios() {
      return [
        "PAGAMENTO_DE_PESSOAL",
        "DARF",
        "DAM",
        "GPS",
        "IMPOSTOS_E_TAXAS",
        "ADIANTAMENTO_DE_DESPESAS",
        "ADIANTAMENTO_FORNECEDOR",
        "DAE",
      ];
    },
    desabilitarPorTipoDeDocumento() {
      let pagItensPagamentos = this.tiposDeDocumentosNaoObrigatorios;
      let filterQualPagamento = pagItensPagamentos.filter((itemPag) => {
        return this.solicitacao.tipoDoDocumento == itemPag;
      });
      if (filterQualPagamento.length > 0) return true;
      else return false;
    },
    verificarPerfilFinanceiro() {
      if (
        this.loggedUser.papeis.filter(
          (papel) => papel.nome === "APROVADOR_FINANCEIRO"
        ).length != 0 &&
        (this.solicitacao.status == "ENVIADO_PARA_FINANCEIRO" ||
          this.solicitacao.status == "REPROVADO_PELO_PROCURADOR")
      ) {
        return true;
      } else return false;
    },
    verificarAnexoContabilidade() {
      if (
        this.loggedUser.papeis.filter(
          (papel) => papel.nome === "APROVADOR_CONTABILIDADE"
        ).length != 0 &&
        this.solicitacao.status == "ENVIADO_PARA_CONTABILIDADE"
      ) {
        return true;
      } else {
        return false;
      }
    },
    ...mapState({
      loggedUser: (state) => state.loggedUser,
      fornecedores: (state) => state.fornecedoresDoTipo,
      loadingProviders: (state) => state.loadingProviders,
      contasGerenciais: (state) => state.contasGerenciais,
      empresas: (state) => state.empresas,
      loadingCompanies: (state) => state.loadingCompanies,
      loadingViewRequest: (state) => state.loadingViewRequest,
    }),
    validarComBaseNoTipoDePagamento() {
      if (this.solicitacao.formaDePagamento != 'DEPÓSITO' &&
        this.solicitacao.formaDePagamento != 'BOLETO') return this.validacaoVencimentoSeletor;
      else return this.parcelasValidadas;
    }
  },
  watch: {
    dialogCentro(val) {
      if (!val) {
        this.close({
          dialogName: "dialogCentro",
          formName: "formCentros",
          itemName: "editedCostCenter",
          defaultItemName: "defaultCostCenter",
        });
        this.editedCenterIndex = -1;
        this.contasGerenciaisPorEmpresa = [];
      }
    },
    "solicitacao.empresaId"(newVal) {
      this.getCentrosDeCustosPorEmpresa(newVal);
    },
    async editedCostCenter(val) {
      if (get(val, "id", null) === null) return;
      if (val === undefined) return;

      this.loadingContaGerencial = true;
      await this.carregarDados(`/contasgerenciais/centrodecustos/${val.id}`)
        .then((s) => {
          this.contasGerenciaisPorEmpresa = s.data;
        })
        .finally((s) => (this.loadingContaGerencial = false));
    },
    validacaoDataDeVencimentoDasParcelas(statusValidacao) {
      this.validarTodasParcelas(statusValidacao);
    },
  },
  components: {
    ImportarRateios,
    LogsPedidos,
    IntegracaoMensagem,
    "c-impostos": Impostos,
    "c-seletor-data": SeletorData
  },
};
</script>

<style scoped>
.texto {
  color: #005ca3;
  font-weight: bold;
}

.flex {
  padding: 16px;
}

.noDataSlot {
  font-size: 1em;
  padding: 10px;
}

.tabela>>>thead {
  background-color: #cfd8dc;
}

.tabela>>>th {
  color: #455a64 !important;
}

.tabela>>>th i {
  color: #455a64 !important;
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: hsla(0, 0%, 16%, 0.12) !important;
}
</style>
